import React from 'react'
import { useInView } from 'react-intersection-observer'

import Breadcrumb from '../breadcrumb'
import Wysiwyg from '../wysiwyg'
import Image from '../image'

import hexagonShape from '../../icons/hexagon-shape.svg'
import semiroundShape from '../../icons/semiround-shape.svg'
import slugify from 'slugify'

const OfferHero = ({data, currentUrl}) => {
  const { ref, inView} = useInView({ threshold: 0.3, triggerOnce: true})
  const chapo = (data.chapo) ? data.chapo : null
  const breadcrumbLabel = (data.breadcrumbCurrentLabel) ? data.breadcrumbCurrentLabel : data.title
  const type = slugify(data.solution.fields ? data.solution.fields.solution : data.solution.solution).toLowerCase()

  let semiroundColor = null
  let hexagonColor = null

  switch(type) {
    case 'hydrogene':
      semiroundColor = 'turquoise'
      hexagonColor = 'gradient-purple'
      break
    case 'digital':
      semiroundColor = 'orange'
      hexagonColor = 'gradient-sienne2'
      break
    case 'mobilite-bas-carbone':
      semiroundColor = 'sienne'
      hexagonColor =  'gradient-aqua'
      break
    case 'methanisation':
      semiroundColor = 'night'
      hexagonColor = 'gradient-green'
      break
    case 'co2':
      semiroundColor = 'tumbleweed'
      hexagonColor = 'gradient-co2-2'
      break
    default:
      return 'error'
  }

  return (
    <div className={`hero offer-hero offer-hero--${type} has-full-bg ${inView ? 'has-anim' : ''}`} ref={ref}>
      <Breadcrumb
        currentUrl={currentUrl}
        links={data.breadcrumb ? data.breadcrumb : null} 
        current={breadcrumbLabel}
        type="solution"
        isAbsolute={true}
      />
      <div className="row items-start">
        <div className={`col-12 md-col-6 lg-col-6 xl-col-7 order-last md:order-first`}>
          <div className="relative">
            <h1 className="title title-page title-page--big offer-hero__title scroll-anim-el">
              <span className={`text-${type === 'co2' ? 'white' : 'turquoise'} block`}>{data.titleLine1}</span>
              {data.titleLine2 &&
                data.titleLine2
              }
            </h1>

            { chapo &&
              <div className="row mt-6 md:mt-8">
                <div className="col-12 xl-col-5">
                  <Wysiwyg classes="paragraph-big scroll-anim-el scroll-anim-el--2" document={chapo} />
                </div>
              </div>
            }
          </div>
        </div>
        <div className="col-12 md-col-6 lg-col-6 xl-col-5 relative">
          <div className="offer-hero__shape shaped-image shaped-image--hero-offer">
            { data.mainImage &&
            <Image
              width="1082"
              height="1098"
              isTop={true}
              classes="object-fit-image offer-hero__img"
              sizes={{"415": [400, 400], "767": [600, 700], "1023": [416, 508], "1600": [675, 734] }}
              image={data.mainImage} />
            }
          </div>
          
          <svg className={`absolute icon-${semiroundColor} offer-hero__semiround`} width="61" height="72">
            <use xlinkHref={semiroundShape.url} />
          </svg>

          { data.logo
            ? <div className="offer-hero__hexagon offer-hero__logo absolute shaped-image shaped-image--hexagon">
                <Image
                  width="230"
                  maxWidth={true}
                  classes="object-fit-image"
                  image={data.logo} />
              </div>
            : <svg className={`absolute icon-${hexagonColor} offer-hero__hexagon`} width="200px" height="200px">
                <use xlinkHref={hexagonShape.url} />
              </svg>
          }
        </div>
      </div>
    </div>
  )
}

export default OfferHero